import React from "react";
import { Box, Text } from "@chakra-ui/react";
import { ArrowUpCircleIcon } from "@heroicons/react/24/solid";
import { Button } from "./button";
import { UpsellBadge } from "./upsell-badge";
export function UpsellCard({ badgeText, title, children, actionText, onAction, ...props }) {
    return (React.createElement(Box, { border: "1px", borderColor: "ocean", borderRadius: "md", bg: "gray.100", px: 6, py: 4, ...props },
        React.createElement(UpsellBadge, null, badgeText),
        React.createElement(Text, { as: "h3", color: "space", fontSize: "md", fontWeight: "medium", mt: 4 }, title),
        React.createElement(Box, { mt: 2, maxWidth: "65ch" }, children),
        React.createElement(Box, { mt: 6 },
            React.createElement(Button, { icon: ArrowUpCircleIcon, onClick: onAction }, actionText))));
}
